import React from 'react';
import Select from '@material-ui/core/Select';
import { MenuItem, Grid, OutlinedInput } from '@material-ui/core';
import SelectCustom from './input/SelectCustom'
export default function ColumnsListDropdown (props) {
  return (
    <SelectCustom value={props.value} values={props.columns} valueKey="alias_path" label={props.label} onChange={props.onChange} shouldForwardEvent={false} />
  );
}
